import { render, staticRenderFns } from "./ChatFormCard.vue?vue&type=template&id=10f5fb58"
import script from "./ChatFormCard.vue?vue&type=script&lang=js"
export * from "./ChatFormCard.vue?vue&type=script&lang=js"
import style0 from "./ChatFormCard.vue?vue&type=style&index=0&id=10f5fb58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports